module.exports = __webpack_public_path__ + "static/img/logo9.55526ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/logo9.png
// module id = V7GS
// module chunks = 1